import { App, Button } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { PickOption, searchUserOptions } from 'components/add-members-modal';
import DebounceSelect from 'components/debounce-select/select';
import { listStaff, saveStaff } from '../api';
import { StaffBrief, errorText } from '../contract';
import styles from '../styles.module.scss';

const toOption = (s: StaffBrief): PickOption => ({
  value: s.id,
  label: `${s.nickName || s.username} (@${s.username})`,
});

/** Khối "Ai được quét": chọn tài khoản được phép dùng Quầy quét ở app (ADMIN luôn quét được). */
const ScanStaffSection = ({ eventId }: { eventId: number }) => {
  const { message } = App.useApp();
  const [picked, setPicked] = useState<PickOption[]>([]);
  const [dirty, setDirty] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const staff = await listStaff(eventId);
      setPicked(staff.map(toOption));
      setDirty(false);
    } catch (e) {
      message.error(errorText(e, 'Không tải được danh sách người được quét.'));
    } finally {
      setLoading(false);
    }
  }, [eventId, message]);

  useEffect(() => {
    load();
  }, [load]);

  const save = async () => {
    setSaving(true);
    try {
      const staff = await saveStaff(eventId, picked.map((p) => Number(p.value)));
      setPicked(staff.map(toOption));
      setDirty(false);
      message.success('Đã lưu danh sách người được quét.');
    } catch (e) {
      message.error(errorText(e, 'Không lưu được danh sách người được quét.'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className={styles.card} aria-label="Ai được quét">
      <h3 className={styles.cardTitle}>Ai được quét</h3>
      <p className={styles.hint}>
        Những tài khoản này thấy nút "Quầy quét" trong app để check-in khách. Admin luôn quét được, không cần thêm vào đây.
      </p>
      <DebounceSelect
        mode="multiple"
        value={picked as any}
        loading={loading}
        fetchOptions={searchUserOptions}
        onChange={(v: any) => {
          setPicked(Array.isArray(v) ? (v as PickOption[]) : []);
          setDirty(true);
        }}
        style={{ width: '100%', marginTop: 12 }}
        placeholder="Tìm theo tên, @username, email, UID…"
        aria-label="Tìm tài khoản được quét"
      />
      <div style={{ marginTop: 12 }}>
        <Button type="primary" onClick={save} loading={saving} disabled={!dirty}>
          Lưu danh sách
        </Button>
      </div>
    </section>
  );
};

export default ScanStaffSection;
